import { E_ROUTE_COMPANY_ORGANIZATION } from './route.types';
const routes = [
    {
        name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES,
        path: '/companies',
        component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/Companies/Companies.vue'),
        props(route) {
            return {
                query: route.query,
            };
        },
        meta: {
            breadcrumb: [
                {
                    text: 'backoffice.nav.company_man',
                    active: true,
                }
            ],
            permission: 'CompanyList',
        },
    },
    {
        name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_NEXT,
        path: '/companies/:id',
        component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/Company.vue'),
        redirect: {
            name: E_ROUTE_COMPANY_ORGANIZATION.CUSTOMER_360,
        },
        props: true,
        children: [
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.CUSTOMER_360,
                path: '/companies/:id/customer360',
                component: () => import(/* webpackChunkName: "customer360" */ '../../views/company-next/Customer360/Customer360.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: '',
                            active: true,
                        }
                    ],
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_PRODUCTS,
                path: '/companies/:id/products',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyProduct/CompanyProductList/CompanyProductList.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.productList',
                            active: true,
                        }
                    ],
                    permission: 'CompanyInfoProduct',
                },
            },
            {
                name: 'company-privilege',
                path: '/companies/:id/privilege',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyProduct/CompanyPrivilege/CompanyPrivilege.vue'),
                props: true,
                redirect: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_ORDER_LIST },
                children: [
                    {
                        name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_ORDER_LIST,
                        path: '/companies/:id/order/orderList',
                        component: () => import('../../views/company-next/CompanyProduct/CompanyOrderList/CompanyOrderList.vue'),
                        props: true,
                        meta: {
                            parent: 'company-privilege',
                            permission: 'OrdersList',
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.company_man',
                                    to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                                },
                                {
                                    text: 'backoffice.company.order',
                                    active: true,
                                }
                            ],
                        },
                    },
                    {
                        name: 'company-capacity',
                        path: '/companies/:id/capacity',
                        component: () => import('../../views/company-next/CompanyProduct/CompanyCapacity/CompanyCapacity.vue'),
                        props: true,
                        meta: {
                            parent: 'company-privilege',
                            breadcrumb: [
                                {
                                    text: 'backoffice.nav.company_man',
                                    to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                                },
                                {
                                    text: 'backoffice.capacity.capacity',
                                    active: true,
                                }
                            ],
                        },
                    }
                ],
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_ENTERPRISE,
                path: '/companies/:id/enterprise',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyEnterprise/CompanyEnterprise.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.enterpriseConfiguration',
                            active: true,
                        }
                    ],
                    permission: 'SettingsSubmit',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_SELF_REGISTER_AND_PRIVILEGE_SETTING,
                path: '/companies/:id/selfRegisterAndPrivilegeSetting',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/SelfRegisterAndPrivilegeSetting/SelfRegisterAndPrivilegeSetting.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.autoProvision.title',
                            active: true,
                        }
                    ],
                    permission: 'CompanyInfoProduct',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_SAFESETTING,
                path: '/companies/:id/safeSetting',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanySafeSetting/CompanySafeSetting.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.safeSetting',
                            active: true,
                        }
                    ],
                    permission: 'GetSecuritySetting',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_DEFAULT_SETTING,
                path: '/companies/:id/default-setting',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyDefaultPreferences/CompanyDefaultPreferences.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.nav.companyDefaultSetting',
                            active: true,
                        }
                    ],
                    permission: 'CompanyDefaultPreference',
                },
            },
            // Grant
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_GRANT,
                path: '/companies/:id/grant',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyGrant/CompanyGrant.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.grant',
                            active: true,
                        }
                    ],
                    permission: 'CompanyOrganizationDetailInfo',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_SSO,
                path: '/companies/:id/sso',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanySso/CompanySso.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'enum.E_PrivliegeLimitationWay.SSO',
                            active: true,
                        }
                    ],
                    permission: 'SsoSettingSubmit',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_SUBSCRIPTIONS,
                path: '/companies/:id/subscriptions',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanySubscriptions/CompanySubscriptions.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'subscription_rel.management',
                            active: true,
                        }
                    ],
                    permission: 'CompanySubscriptions',
                },
            },
            {
                name: 'company-system-limit',
                path: '/companies/:id/system-limit',
                component: () => import(/* webpackChunkName: "company-system-limit" */ '../../views/company-next/CompanySystemLimit/CompanySystemLimit.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.systemLimit',
                            active: true,
                        }
                    ],
                    permission: 'GetCompanySystemLimit',
                },
            },
            {
                name: 'company-history',
                path: '/companies/:id/history',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyHistory/CompanyHistory.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.nav.historyInformation',
                            active: true,
                        }
                    ],
                    permission: 'CompanyHistoryList',
                },
            },
            {
                name: 'company-accounts',
                path: '/companies/:id/accounts',
                component: () => import(/* webpackChunkName: "company" */ '../../views/account-next/Accounts/Accounts.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.user',
                            active: true,
                        }
                    ],
                    permission: 'CompanyOrganizationAccountList',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_REPORT,
                path: '/companies/:id/report',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyReport/CompanyReport.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.Report',
                            active: true,
                        }
                    ],
                    permission: 'CompanyInfoReport',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_DATA_ANALYSIS,
                path: '/companies/:id/data-analysis/:tab',
                component: () => import(/* webpackChunkName: "company" */ '../../views/company-next/CompanyDataAnalysis/CompanyDataAnalysis.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: 'backoffice.company.Report',
                            active: true,
                        }
                    ],
                    permission: 'CompanyDataAnalysis',
                },
            },
            {
                name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_INSIGHTS,
                path: '/companies/:id/insights',
                component: () => import(/* webpackChunkName: "CompanyInsights" */ '../../views/company-next/company-insights/CompanyInsights.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.company_man',
                            to: { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANIES },
                        },
                        {
                            text: '',
                            active: true,
                        }
                    ],
                    permission: 'CompanyInsights',
                },
            }
        ],
    }
];
export default routes;
/**
 * 公司-组织 页面级子菜单
 * 注意这里的顺序需要和菜单顺序保持一致
 */
export const CompanyOrganizationRoutePermissionTable = [
    { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_PRODUCTS, permission: 'CompanyInfoProduct' },
    { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_ENTERPRISE, permission: 'CompanySetting' },
    { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_ACCOUNTS, permission: 'AccountList' },
    { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_REPORT, permission: 'CompanyInfoReport' },
    { name: E_ROUTE_COMPANY_ORGANIZATION.COMPANY_HISTORY, permission: 'CompanyHistoryList' }
];
